import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vModelText as _vModelText, toHandlerKey as _toHandlerKey, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "qa-range" }
const _hoisted_2 = { class: "qa-range--label" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "qa-range--track" }, null, -1)
const _hoisted_4 = ["min", "max"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "label")
    ]),
    _hoisted_3,
    _withDirectives(_createElementVNode("input", {
      type: "range",
      min: _ctx.min,
      max: _ctx.max,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      onTouchstart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.active = true)),
      onTouchend: _cache[2] || (_cache[2] = ($event: any) => (_ctx.active = false)),
      [_toHandlerKey(_ctx.isIOS?`touchmove`:null)]: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.iosFix && _ctx.iosFix(...args))),
      class: _normalizeClass({ active: _ctx.active })
    }, null, 16, _hoisted_4), [
      [_vModelText, _ctx.value]
    ]),
    (!_ctx.hideTooltip)
      ? (_openBlock(), _createElementBlock("output", {
          key: 0,
          class: "qa-range-bubble mdc-elevation--z2 nowrap",
          style: _normalizeStyle({
        '--position': _ctx.left,
        '--correction': _ctx.correction,
      })
        }, _toDisplayString(_ctx.tooltip || _ctx.value), 5))
      : _createCommentVNode("", true)
  ]))
}